(function() {
    'use strict';

    angular
        .module('app.devengados')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/devengados',
                config: {
                    templateUrl: 'app/devengados/devengados.html',
                    controller: 'Devengados',
                    controllerAs: 'vm',
                    title: 'Devengados'
                }
            },
            {
                url: '/editar-devengado/:id?',
                config: {
                    templateUrl: 'app/devengados/editarDevengado.html',
                    controller: 'EditarDevengado',
                    controllerAs: 'vm',
                    title: 'EditarDevengado'
                }
            },
            {
                url: '/otros-devengados',
                config: {
                    templateUrl: 'app/devengados/otrosDevengados.html',
                    controller: 'OtrosDevengados',
                    controllerAs: 'vm',
                    title: 'OtrosDevengados'
                }
            },
            {
                url: '/editar-otro-devengado/:id?',
                config: {
                    templateUrl: 'app/devengados/editarOtroDevengado.html',
                    controller: 'EditarOtroDevengado',
                    controllerAs: 'vm',
                    title: 'EditarOtroDevengado'
                }
            }            
        ];
    }
})();
